module.exports = __webpack_public_path__ + "static/free-shipping-watermark-7ca408ccae8fb46190bc4422b1cea315.svg";